import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { decryptData } from '../utils/encryptData'

function AdminRoutes() {

    const { isAuthenticated, rl } = useSelector((state) => state.auth);

    const decryptRole = decryptData(rl);

    return (
        isAuthenticated && decryptRole === 'admin' ? <Outlet /> : <Navigate to="/login" />
    );
}

export default AdminRoutes;
